import { Grid } from "@mui/material";
import React, { useContext } from "react";
import { ReportsFragmentContext } from "../../../ReportFragment.jsx";
import CourseStudentAnalyticsMetaSelection from "./meta-selection/course-student-analytics-meta-selection.tsx";
import CourseStudentAnalytics from "./analytics/course-student-analytics.tsx";

const CourseStudentAnalyticsSubFragment = () => {

    //@ts-ignore
    const { viewHandler, setViewHandler } = useContext(ReportsFragmentContext);
    return (
        <React.Fragment>
            <Grid item sm={10} style={{ height: '92vh', overflowY: 'scroll', padding: '20px', width: '100%', fontFamily: "Noto Sans", fontWeight: '500', justifyContent: 'start', alignContent: 'center', alignItems: 'start', display: 'flex', flexDirection: 'column' }}>
                {
                    viewHandler?.subView !== 'course-student-analytics' ?
                        <CourseStudentAnalyticsMetaSelection />
                        :
                        <CourseStudentAnalytics />
                }
            </Grid>
        </React.Fragment>
    );
};

export default CourseStudentAnalyticsSubFragment;